export default "__VITE_ASSET__DqMktYTP__"